import React from "react"
import PropTypes from "prop-types"
import SECTIONS from "utils/sectionConstants"
import ClinicsDetails from "views/clinicDetails"
import ClinicHero from "components/blocks/clinicHero"
import { PageHeaderProps } from "components/sections/pageHeader"

const ClinicTemplate = ({
  clinic,
  closingCta,
  insuranceLogos,
  insurerLogos,
  overrideAssets,
  sections,
  services,
}) =>
  sections.map((section, i) => {
    switch (section.__typename) {
      case SECTIONS.Subheader:
        return (
          <ClinicHero clinic={clinic} key={i} overrideAssets={overrideAssets} />
        )

      case SECTIONS.TemplateDetailsSection:
        return (
          <ClinicsDetails
            clinic={{
              ...clinic,
              enableDirectionsCTA:
                section.additionalSettings?.enableDirectionsCTA,
            }}
            closingCta={closingCta}
            insuranceLogos={insuranceLogos}
            insurerLogos={insurerLogos}
            key={i}
            overrideAssets={overrideAssets}
            services={services}
          />
        )

      default:
        return null
    }
  })

const TemplateSectionProps = {
  __typename: PropTypes.string,
  additionalSettings: PropTypes.shape({
    enableDirectionsCTA: PropTypes.bool,
  }),
  title: PropTypes.string,
}

export const ClinicTemplateDetailsProps = ClinicsDetails.props

ClinicTemplate.props = {
  model: PropTypes.string,
  sections: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape(PageHeaderProps),
      PropTypes.shape(TemplateSectionProps),
    ])
  ),
  slugPrefix: PropTypes.string,
  title: PropTypes.string,
}

ClinicTemplate.propTypes = {
  ...ClinicTemplate.props,
  clinic: PropTypes.shape(ClinicsDetails.props),
  closingCta: PropTypes.object,
  insuranceLogos: PropTypes.array,
  insurerLogos: PropTypes.array,
  overrideAssets: PropTypes.array,
  services: PropTypes.object,
}

export default ClinicTemplate
